import {
  B100080Mode,
  getSCode,
  SakujoyoteiKbn,
  ShokuchiKbn,
} from "messages/codes";
import { UseFormReturn } from "react-hook-form";
import {
  B000111ShirebunNm1,
  B000111ShirebunNm2,
  B000111ShirebunNm3,
  B000111ShirebunNm4,
  B000111ShirebunNm5,
  B000130BumonNm,
  B000140ShainNmBumonCd,
} from "..";
import { catchRestError, RestClient } from "../RestClient";

// 作成途中
export type B100080CreateRequest = {
  shireCd: string;
  shireNm1: string;
  shireNmr: string;
  shokuchiKbn: string;
  shainCd: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  sakujoyoteiKbn: string;
} & Partial<{
  shireNm2: string;
  shireKana: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shirebunCd1: string;
  shirebunCd2: string;
  shirebunCd3: string;
  shirebunCd4: string;
  shirebunCd5: string;
}>;

// 新規登録処理
export const B100080Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100080CreateRequest = {
    shireCd: fields.shireCd,
    shireNm1: fields.shireNm1,
    shireNmr: fields.shireNmr,
    shokuchiKbn: fields.shokuchiKbn.value,
    shainCd: fields.shainCd,
    torihikikaishiYmd: fields.torihikikaishiYmd,
    torihikishuryoYmd: fields.torihikishuryoYmd,
    sakujoyoteiKbn: fields.sakujoyoteiKbn.value,
    shireNm2: fields.shireNm2,
    shireKana: fields.shireKana,
    postCd: fields.postCd,
    address1: fields.address1,
    address2: fields.address2,
    telNo: fields.telNo,
    faxNo: fields.faxNo,
    shirebunCd1: fields.shirebunCd1,
    shirebunCd2: fields.shirebunCd2,
    shirebunCd3: fields.shirebunCd3,
    shirebunCd4: fields.shirebunCd4,
    shirebunCd5: fields.shirebunCd5,
  };

  return RestClient.post("b100080/create", data);
};

export type B100080UpdateRequest = {
  shireCd: string;
  shireNm1: string;
  shireNmr: string;
  shokuchiKbn: string;
  shainCd: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  sakujoyoteiKbn: string;
  version: string;
} & Partial<{
  shireNm2: string;
  shireKana: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shirebunCd1: string;
  shirebunCd2: string;
  shirebunCd3: string;
  shirebunCd4: string;
  shirebunCd5: string;
}>;

export const B100080Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100080UpdateRequest = {
    shireCd: fields.shireCd,
    shireNm1: fields.shireNm1,
    shireNmr: fields.shireNmr,
    shokuchiKbn: fields.shokuchiKbn.value,
    shainCd: fields.shainCd,
    torihikikaishiYmd: fields.torihikikaishiYmd,
    torihikishuryoYmd: fields.torihikishuryoYmd,
    sakujoyoteiKbn: fields.sakujoyoteiKbn.value,
    version: fields.version,
    shireNm2: fields.shireNm2,
    shireKana: fields.shireKana,
    postCd: fields.postCd,
    address1: fields.address1,
    address2: fields.address2,
    telNo: fields.telNo,
    faxNo: fields.faxNo,
    shirebunCd1: fields.shirebunCd1,
    shirebunCd2: fields.shirebunCd2,
    shirebunCd3: fields.shirebunCd3,
    shirebunCd4: fields.shirebunCd4,
    shirebunCd5: fields.shirebunCd5,
  };

  return RestClient.put("b100080/update", data);
};

export type B100080GetRequest = {
  shireCd: string;
} & Partial<{}>;

export const B100080Get = (props: B100080GetRequest) => {
  return RestClient.get("b100080/get", {
    params: props,
  });
};

// 仕入先名(From)取得メソッド
export const B100080ShireNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shireCdFrom === "") {
    methods.setValue("shireNmFrom", "");
    return;
  }
  await B100080Get({
    shireCd: data.shireCdFrom,
  })
    .then((response) => {
      methods.setValue("shireNmFrom", response.data.shireNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNmFrom", "");
    });
};

// 仕入先名(To)取得メソッド
export const B100080ShireNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shireCdTo === "") {
    methods.setValue("shireNmTo", "");
    return;
  }
  await B100080Get({
    shireCd: data.shireCdTo,
  })
    .then((response) => {
      methods.setValue("shireNmTo", response.data.shireNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNmTo", "");
    });
};

// 仕入先情報表示処理
export const B100080Shire = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない
  if (!methods.getFieldState("shireCd").isDirty) {
    return;
  }

  const data = methods.getValues();
  if (data.shireCd === "") {
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      shireCd: "",
      sanshoShireCd: "",
    });
    methods.setValue("modeKbn", getSCode(B100080Mode, data.modeKbn?.value));
    return;
  }
  await B100080Get({
    shireCd: data.shireCd,
  })
    .then((response) => {
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("shireNm1", response.data.shireNm1 ?? "");
      methods.setValue("shireNm2", response.data.shireNm2 ?? "");
      methods.setValue("shireNmr", response.data.shireNmr ?? "");
      methods.setValue("shireKana", response.data.shireKana ?? "");
      methods.setValue("postCd", response.data.postCd ?? "");
      methods.setValue("address1", response.data.address1 ?? "");
      methods.setValue("address2", response.data.address2 ?? "");
      methods.setValue("telNo", response.data.telNo ?? "");
      methods.setValue("faxNo", response.data.faxNo ?? "");
      methods.setValue(
        "shokuchiKbn",
        getSCode(ShokuchiKbn, response.data.shokuchiKbn) ?? null
      );
      methods.setValue(
        "torihikikaishiYmd",
        response.data.torihikikaishiYmd ?? null
      );
      methods.setValue(
        "torihikishuryoYmd",
        response.data.torihikishuryoYmd ?? null
      );
      methods.setValue("shirebunCd1", response.data.shirebunCd1 ?? "");
      methods.setValue("shirebunCd2", response.data.shirebunCd2 ?? "");
      methods.setValue("shirebunCd3", response.data.shirebunCd3 ?? "");
      methods.setValue("shirebunCd4", response.data.shirebunCd4 ?? "");
      methods.setValue("shirebunCd5", response.data.shirebunCd5 ?? "");
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );
      methods.setValue("version", response.data.version ?? "");

      // 値を保持
      methods.unregister("shireCd", { keepValue: true });

      // コードに紐づく名称の設定
      B100080HandleSetNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        sanshoShireCd: "",
      });
      methods.setValue("shireCd", data.shireCd);
      methods.setValue("modeKbn", getSCode(B100080Mode, data.modeKbn?.value));
      catchRestError(reason, navigate, setMsg);
    });
};

// 参照仕入先情報表示処理
export const B100080SanshoShire = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない
  if (!methods.getFieldState("sanshoShireCd").isDirty) {
    return;
  }

  const data = methods.getValues();
  if (data.sanshoShireCd === "") {
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      shireCd: "",
      sanshoShireCd: "",
    });
    methods.setValue("modeKbn", getSCode(B100080Mode, data.modeKbn?.value));
    return;
  }
  await B100080Get({
    shireCd: data.sanshoShireCd,
  })
    .then((response) => {
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("shireNm1", response.data.shireNm1 ?? "");
      methods.setValue("shireNm2", response.data.shireNm2 ?? "");
      methods.setValue("shireNmr", response.data.shireNmr ?? "");
      methods.setValue("shireKana", response.data.shireKana ?? "");
      methods.setValue("postCd", response.data.postCd ?? "");
      methods.setValue("address1", response.data.address1 ?? "");
      methods.setValue("address2", response.data.address2 ?? "");
      methods.setValue("telNo", response.data.telNo ?? "");
      methods.setValue("faxNo", response.data.faxNo ?? "");
      methods.setValue(
        "shokuchiKbn",
        getSCode(ShokuchiKbn, response.data.shokuchiKbn) ?? null
      );
      methods.setValue(
        "torihikikaishiYmd",
        response.data.torihikikaishiYmd ?? null
      );
      methods.setValue(
        "torihikishuryoYmd",
        response.data.torihikishuryoYmd ?? null
      );
      methods.setValue("shirebunCd1", response.data.shirebunCd1 ?? "");
      methods.setValue("shirebunCd2", response.data.shirebunCd2 ?? "");
      methods.setValue("shirebunCd3", response.data.shirebunCd3 ?? "");
      methods.setValue("shirebunCd4", response.data.shirebunCd4 ?? "");
      methods.setValue("shirebunCd5", response.data.shirebunCd5 ?? "");
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );

      // 値を保持
      methods.unregister("sanshoShireCd", { keepValue: true });

      // コードに紐づく名称の設定
      B100080HandleSetNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        sanshoShireCd: "",
      });
      methods.setValue("sanshoShireCd", data.sanshoShireCd);
      methods.setValue("modeKbn", getSCode(B100080Mode, data.modeKbn?.value));
      catchRestError(reason, navigate, setMsg);
    });
};

// コードに紐づく名称の設定
export const B100080HandleSetNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 担当者名・担当部門名表示
  (async () => {
    // 担当者名を取得
    await B000140ShainNmBumonCd(methods, navigate, setMsg);
    // 担当部門名を取得
    await B000130BumonNm(methods, navigate, setMsg);
  })();

  // 仕入先分類名 1 表示
  B000111ShirebunNm1(methods, navigate, setMsg);

  // 仕入先分類名 2 表示
  B000111ShirebunNm2(methods, navigate, setMsg);

  // 仕入先分類名 3 表示
  B000111ShirebunNm3(methods, navigate, setMsg);

  // 仕入先分類名 4 表示
  B000111ShirebunNm4(methods, navigate, setMsg);

  // 仕入先分類名 5 表示
  B000111ShirebunNm5(methods, navigate, setMsg);
};
